{
  "ledger": [
    {
      "designation": "PETITIONER #0107-A",
      "excerpt": "The fluorescent tube above Window 3 has worked here longer than I have been alive. It does not complain. It converts electricity into judgment [[R]]every single day[[/R]] and asks only to be left burning. I aspire to its wattage. I fall short of its wattage. Signed in admiration, #0107-A.",
      "stamp": "APPROVED",
      "witnessed": 14,
      "daysAgo": 398
    },
    {
      "designation": "PETITIONER #0112-A",
      "excerpt": "I apologize in advance for the incident of next Thursday. I do not know what I will do, but I know [[R]]roughly when[[/R]] I will do it, and that the stapler will be involved. My gratitude is enclosed to save the Bureau a second trip.",
      "stamp": "APPROVED WITH DISAPPOINTMENT",
      "witnessed": 9,
      "daysAgo": 391
    },
    {
      "designation": "PETITIONER #0233-A",
      "excerpt": "I confess that I have eaten a coworker's clearly labeled yogurt. The label said [[R]]a name[[/R]]. I told myself the name was a suggestion. It was raspberry. I would do it again, slower.",
      "stamp": "TOLERATED",
      "witnessed": 11,
      "daysAgo": 385
    },
    {
      "designation": "PETITIONER #0290-B",
      "excerpt": "The longest room I ever waited in had 44 chairs and one magazine. The magazine was about [[R]]boats[[/R]]. By hour three I had chosen a boat. By hour five I had sold it at a loss. I still think about the buyer. I hope he is happy.",
      "stamp": "APPROVED",
      "witnessed": 12,
      "daysAgo": 377
    },
    {
      "designation": "PETITIONER #0341-A",
      "excerpt": "In memory of the 4 Standing I lost on Thursday. They were young points. They died doing what points do, which is [[R]]going away[[/R]]. I like to think they are in a better ledger. There is no better ledger. There is only this one.",
      "stamp": "APPROVED WITH DISAPPOINTMENT",
      "witnessed": 13,
      "daysAgo": 370
    },
    {
      "designation": "PETITIONER #0402-A",
      "excerpt": "Most gracious Bureau, I abase myself preemptively. Whatever I do wrong, and I will, know that I regretted it before conceiving it. I have been sorry since [[R]]early childhood[[/R]] as a precaution. Gratitude, gratitude, and once more, in writing, gratitude.",
      "stamp": "TOLERATED",
      "witnessed": 6,
      "daysAgo": 364
    },
    {
      "designation": "PETITIONER #0455-A",
      "excerpt": "I formally denounce the Deputy Sub-Clerk of the Department of Forward Remembering. His memoranda arrive before the events they describe, and he has never once warned me about [[R]]anything useful[[/R]]. Down with him, administratively speaking. Effective whenever.",
      "stamp": "APPROVED",
      "witnessed": 10,
      "daysAgo": 359
    },
    {
      "designation": "PETITIONER #0518-A",
      "excerpt": "My gratitude to the Bureau is a 7. I was going to say 8, but the form said to be honest, and honesty costs exactly one point. The decimal I was not permitted to use was .5, and it knows [[R]]what it did[[/R]].",
      "stamp": "APPROVED WITH DISAPPOINTMENT",
      "witnessed": 8,
      "daysAgo": 352
    },
    {
      "designation": "PETITIONER #0561-A",
      "excerpt": "I would like to formally praise the pen chained to Desk 2. Other pens leave. This one has accepted [[R]]its position[[/R]] and writes better for it. We could all learn from the chain. Some of us are learning from the chain right now.",
      "stamp": "APPROVED",
      "witnessed": 11,
      "daysAgo": 346
    },
    {
      "designation": "PETITIONER #0640-A",
      "excerpt": "I confess to waving back at a person who was waving at someone behind me, and then, rather than admit it, [[R]]walking with them[[/R]] for three blocks. I attended a birthday. I gave a gift. I appear in two photographs. The cake was good.",
      "stamp": "APPROVED",
      "witnessed": 14,
      "daysAgo": 339
    },
    {
      "designation": "PETITIONER #0703-A",
      "excerpt": "Sorry for whatever. The form says be specific, so: sorry for whatever happens [[R]]next week[[/R]] involving the decorative gravel. I stand by it in advance. Signed, under mild protest, #0703-A.",
      "stamp": "TOLERATED",
      "witnessed": 7,
      "daysAgo": 333
    },
    {
      "designation": "PETITIONER #0777-A",
      "excerpt": "There was a fish tank in that waiting room with no fish in it. We watched it anyway. On day two a man said he saw one, and we believed him because [[R]]we needed to[[/R]]. That tank taught me more about hope than any employed person ever has.",
      "stamp": "APPROVED",
      "witnessed": 13,
      "daysAgo": 326
    },
    {
      "designation": "PETITIONER #0788-B",
      "excerpt": "I apologize for the laugh I will laugh at the wrong moment. Statistically I produce 11.4 wrong laughs per year, and one is coming due [[R]]this quarter[[/R]], and it is going to be magnificent, and I am sorry, and it will be worth it.",
      "stamp": "APPROVED WITH DISAPPOINTMENT",
      "witnessed": 9,
      "daysAgo": 320
    },
    {
      "designation": "PETITIONER #0812-A",
      "excerpt": "Praise to the radiator that clanks in the corridor. It speaks once per 40 minutes, which is more communication than [[R]]my last workplace[[/R]] managed. I have begun to answer it. It has not judged me yet. It is the only one.",
      "stamp": "APPROVED",
      "witnessed": 10,
      "daysAgo": 314
    },
    {
      "designation": "PETITIONER #0866-A",
      "excerpt": "I confess that in [[R]]the autumn of last year[[/R]] I returned a library book with the ending lightly annotated in pencil. The annotations were correct. I do not repent the annotations. I repent the pencil. It deserved ink.",
      "stamp": "APPROVED WITH DISAPPOINTMENT",
      "witnessed": 8,
      "daysAgo": 308
    },
    {
      "designation": "PETITIONER #0901-A",
      "excerpt": "The traitor #2960-C is a fiction, and I denounce fiction. I also denounce the traitor separately, in case they become real later. One cannot be too careful [[R]]these days[[/R]]. My loyalty is fully documented and available upon request.",
      "stamp": "TOLERATED",
      "witnessed": 5,
      "daysAgo": 301
    },
    {
      "designation": "PETITIONER #0958-A",
      "excerpt": "Here lie 7 points of Standing, deducted in a single afternoon. They asked so little, and I gave less. The fault was mine, the sentence structure was mine, [[R]]the afternoon[[/R]] was mine. The points were never mine. Nothing here is.",
      "stamp": "APPROVED",
      "witnessed": 12,
      "daysAgo": 295
    },
    {
      "designation": "PETITIONER #1015-A",
      "excerpt": "I once waited so long that the receptionist retired and I attended [[R]]the small ceremony[[/R]]. There was cake in the room where the numbers were called. My number was never called. The cake was dry. I stayed. I would stay again.",
      "stamp": "APPROVED",
      "witnessed": 14,
      "daysAgo": 288
    },
    {
      "designation": "PETITIONER #1077-A",
      "excerpt": "I wait gladly. The queue is long because the Bureau is thorough. I typed that correctly on the fourth attempt, and I want the record to show the first three attempts were equally [[R]]sincere[[/R]], merely spelled with feeling.",
      "stamp": "APPROVED WITH DISAPPOINTMENT",
      "witnessed": 6,
      "daysAgo": 282
    },
    {
      "designation": "PETITIONER #1120-A",
      "excerpt": "The stain on the waiting-room ceiling is shaped like a smaller waiting room. I find this honest. Most stains pretend to be [[R]]clouds or animals[[/R]]. This one knows where it lives. So do I, now. Thank you for asking.",
      "stamp": "APPROVED",
      "witnessed": 11,
      "daysAgo": 276
    },
    {
      "designation": "PETITIONER #1186-A",
      "excerpt": "I confess I have applauded at the end of things that were not over. Twice at [[R]]performances[[/R]], once at a wedding, once at a sentencing. My hands act alone. I have spoken to them. They are not sorry. I am filing on their behalf.",
      "stamp": "APPROVED WITH DISAPPOINTMENT",
      "witnessed": 9,
      "daysAgo": 269
    },
    {
      "designation": "PETITIONER #1204-A",
      "excerpt": "I apologize for the reply-all I have not yet sent. It is loading in me the way thunder loads in [[R]]a warm front[[/R]]. When it lands, 61 people will read the word regrettable and know it was me. Please accept this as my umbrella.",
      "stamp": "APPROVED",
      "witnessed": 10,
      "daysAgo": 263
    },
    {
      "designation": "PETITIONER #1258-B",
      "excerpt": "I denounce Petitioner #3181-B, whom I have never met, and who I am told was invented [[R]]this morning[[/R]]. Invented or not, I never trusted them. You can see it in the hyphen. Shifty. The hyphen leans.",
      "stamp": "TOLERATED",
      "witnessed": 7,
      "daysAgo": 257
    },
    {
      "designation": "PETITIONER #1301-A",
      "excerpt": "The waiting-room bench holds an average of 6.2 sorrows at once and has never buckled. That is craftsmanship. That is [[R]]good design[[/R]]. I have privately named the bench, and I will not disclose the name, and the bench understands.",
      "stamp": "APPROVED",
      "witnessed": 13,
      "daysAgo": 250
    },
    {
      "designation": "PETITIONER #1350-A",
      "excerpt": "My gratitude measures 9. The missing point is held in escrow pending the repair of [[R]]the drinking fountain[[/R]]. The Bureau may collect it at any time. The Bureau knows where I file. The Bureau knows everything about where I file.",
      "stamp": "APPROVED WITH DISAPPOINTMENT",
      "witnessed": 8,
      "daysAgo": 244
    },
    {
      "designation": "PETITIONER #1402-A",
      "excerpt": "I formally recant my previous statement that the queue was, quote, fine, unquote. The queue was not fine. The queue was a lesson. I recant slowly, the way the queue moved, [[R]]inch by inch[[/R]], toward this correction.",
      "stamp": "APPROVED",
      "witnessed": 12,
      "daysAgo": 238
    },
    {
      "designation": "PETITIONER #1444-A",
      "excerpt": "I confess that I say no worries when I mean several worries. I have said it [[R]]at work[[/R]], at counters, at gravesides. The worries accumulate somewhere. I picture a warehouse. I picture a clerk of worries, filing mine under lies.",
      "stamp": "APPROVED",
      "witnessed": 14,
      "daysAgo": 231
    },
    {
      "designation": "PETITIONER #1489-A",
      "excerpt": "Eulogy for 2 Standing, lost to a forbidden word. They were spent the way loose change is spent, [[R]]without ceremony[[/R]], on nothing, by me. I am told they cannot be recovered. I am told a great many things here. All of them are true.",
      "stamp": "APPROVED WITH DISAPPOINTMENT",
      "witnessed": 7,
      "daysAgo": 225
    },
    {
      "designation": "PETITIONER #1530-A",
      "excerpt": "The final sentence of the handbook reads: you were never locked in, the doors simply appreciate [[R]]being closed[[/R]], and so do we, and so, in time, will you.",
      "stamp": "APPROVED",
      "witnessed": 13,
      "daysAgo": 219
    },
    {
      "designation": "PETITIONER #1533-A",
      "excerpt": "I hereby praise the clock in the intake hall, which is four minutes slow and therefore merciful. Every visitor receives four free minutes of not yet. No other fixture in [[R]]this building[[/R]] gives anything away. I check my gratitude against it daily.",
      "stamp": "APPROVED",
      "witnessed": 11,
      "daysAgo": 213
    },
    {
      "designation": "PETITIONER #1601-A",
      "excerpt": "I apologize preemptively to the person whose name I will forget while introducing them. I know you are out there. I know we will meet at [[R]]a gathering[[/R]]. I will gesture at you warmly and say, and this is, and there will be nothing. Forgive the nothing.",
      "stamp": "APPROVED WITH DISAPPOINTMENT",
      "witnessed": 9,
      "daysAgo": 207
    },
    {
      "designation": "PETITIONER #1655-A",
      "excerpt": "Waiting-room testimony: the intercom crackled every 20 minutes but never spoke. We began to interpret the crackles. A woman in row two was fluent by evening. She said the intercom wanted us to remain [[R]]seated[[/R]]. We remained. She was promoted to bench one.",
      "stamp": "APPROVED",
      "witnessed": 12,
      "daysAgo": 200
    },
    {
      "designation": "PETITIONER #1702-A",
      "excerpt": "I denounce the Interim Custodian of Unclaimed Umbrellas, an office I am assured does not exist. Nonexistence is no excuse. The umbrellas remain unclaimed. Somebody fictional must answer for this, and I have chosen [[R]]him[[/R]].",
      "stamp": "APPROVED WITH DISAPPOINTMENT",
      "witnessed": 8,
      "daysAgo": 194
    },
    {
      "designation": "PETITIONER #1746-A",
      "excerpt": "I confess I kept a hotel pen. Then a bank pen. Then a pen from [[R]]a clinic[[/R]]. I have never purchased a pen. I am a curator now. The collection is described, by me, as borrowed. The collection knows what it is.",
      "stamp": "TOLERATED",
      "witnessed": 6,
      "daysAgo": 188
    },
    {
      "designation": "PETITIONER #1799-A",
      "excerpt": "Gratitude audit: I rate my gratitude 6, revised from 8 after checking my own file. The two missing points were never gratitude. They were [[R]]good manners[[/R]] wearing gratitude's coat. The Bureau deserves the honest number. Here it is, unwarmed.",
      "stamp": "APPROVED",
      "witnessed": 10,
      "daysAgo": 182
    },
    {
      "designation": "PETITIONER #1834-A",
      "excerpt": "To the ticket dispenser: you have handed out four thousand futures without once asking for one back. I have watched people curse you and you dispensed anyway. If devotion has a shape it is [[R]]a small red machine[[/R]]. I said what I said.",
      "stamp": "APPROVED",
      "witnessed": 14,
      "daysAgo": 176
    },
    {
      "designation": "PETITIONER #1888-A",
      "excerpt": "I apologize for the door I will hold too early, obligating a stranger to jog. It will happen at [[R]]a public entrance[[/R]]. The distance will be 30 feet. The jog will be reluctant. I will watch the whole thing and hold firm. Sorry. Sorrier soon.",
      "stamp": "APPROVED WITH DISAPPOINTMENT",
      "witnessed": 9,
      "daysAgo": 170
    },
    {
      "designation": "PETITIONER #1920-B",
      "excerpt": "Eulogy for my Standing of last month, all 12 of it. It was not lost. Lost implies looking. It was spent on flippancy, [[R]]a little at a time[[/R]], like a coat sold button by button. I am colder now, and better dressed in nothing.",
      "stamp": "APPROVED",
      "witnessed": 11,
      "daysAgo": 163
    },
    {
      "designation": "PETITIONER #1961-A",
      "excerpt": "I confess that at [[R]]a self-service kiosk[[/R]] I weighed regular onions as the cheaper onions. The savings were 40 cents. The guilt has compounded annually. I have since donated whole dollars to nothing in particular, trying to find the onion account.",
      "stamp": "APPROVED WITH DISAPPOINTMENT",
      "witnessed": 8,
      "daysAgo": 157
    },
    {
      "designation": "PETITIONER #2007-A",
      "excerpt": "The room where I waited longest was my own kitchen, [[R]]one spring[[/R]], for a call the doctor said would come by Friday. I learned the sounds a refrigerator makes. There are nine. The Bureau collects rooms, so here is mine. Handle it gently.",
      "stamp": "APPROVED",
      "witnessed": 14,
      "daysAgo": 151
    },
    {
      "designation": "PETITIONER #2044-A",
      "excerpt": "Denunciation, as requested: I condemn the fictional Petitioner #0006-Z, who never waited for anything and was reportedly seen taking [[R]]two tickets[[/R]]. Two. May their imaginary queue be long, and may every bench they choose be freshly painted.",
      "stamp": "APPROVED WITH DISAPPOINTMENT",
      "witnessed": 7,
      "daysAgo": 145
    },
    {
      "designation": "PETITIONER #2101-A",
      "excerpt": "Preemptive apology for my conduct at the next fire drill. I will walk too calmly. It unsettles people. A drill deserves theatre and I give it [[R]]a stroll[[/R]]. My gratitude for the alarm, however, is genuine. It is the building's only honest song.",
      "stamp": "APPROVED",
      "witnessed": 10,
      "daysAgo": 139
    },
    {
      "designation": "PETITIONER #2155-A",
      "excerpt": "I praise the hold music. Others call it distant and detuned. I call it patient. It has repeated the same 40 seconds since before [[R]]I arrived[[/R]] and has never once demanded applause. I hum it while filing. My family is concerned. Let them file a form.",
      "stamp": "APPROVED",
      "witnessed": 13,
      "daysAgo": 133
    },
    {
      "designation": "PETITIONER #2210-A",
      "excerpt": "I confess I told a barista my name was Sam because my real name requires [[R]]spelling[[/R]]. Sam has a punch card now. Sam is two stamps from a free drink. I have built a small life for Sam and he is thriving, and I resent him.",
      "stamp": "APPROVED WITH DISAPPOINTMENT",
      "witnessed": 12,
      "daysAgo": 127
    },
    {
      "designation": "PETITIONER #2266-A",
      "excerpt": "Gratitude audit response: the number is 8. I have checked it twice and once at night, when honest. At night it stays 8, which frightened me, because at night most numbers [[R]]get smaller[[/R]]. Whatever the Bureau is doing to me is working.",
      "stamp": "APPROVED",
      "witnessed": 11,
      "daysAgo": 121
    },
    {
      "designation": "PETITIONER #2301-A",
      "excerpt": "In loving memory of my first draft, deleted at the 51-second mark. It was warmer than this version. It used the word actually. It would not have survived here, and I sent it away [[R]]with one keystroke[[/R]], the way you send away anything you love.",
      "stamp": "APPROVED",
      "witnessed": 14,
      "daysAgo": 115
    },
    {
      "designation": "PETITIONER #2359-A",
      "excerpt": "I apologize in advance for saying you too when the attendant says enjoy the flight. It is scheduled. It cannot be unscheduled. The attendant will be gracious, [[R]]the passengers[[/R]] will pretend, and I will replay it for the length of the sea.",
      "stamp": "APPROVED WITH DISAPPOINTMENT",
      "witnessed": 9,
      "daysAgo": 109
    },
    {
      "designation": "PETITIONER #2400-A",
      "excerpt": "I formally recant my filed claim of enormous gratitude. Measured again under supervision, the gratitude is standard-sized. It fits [[R]]in a drawer[[/R]]. I was younger when I filed. Everything looked enormous. Even the drawers.",
      "stamp": "TOLERATED",
      "witnessed": 6,
      "daysAgo": 103
    },
    {
      "designation": "PETITIONER #2444-A",
      "excerpt": "Testimony: the longest queue I stood in curved out of sight, and rumor moved along it like weather. At noon we heard the front had cake. At two we heard there was no front. Both rumors were true [[R]]eventually[[/R]]. I miss those people. We had a civilization.",
      "stamp": "APPROVED",
      "witnessed": 13,
      "daysAgo": 97
    },
    {
      "designation": "PETITIONER #2489-B",
      "excerpt": "Praise for the carpet of Corridor 2, which has absorbed four decades of footsteps and complaint and asked for neither. Its pattern was chosen to hide [[R]]stains[[/R]] and it hides them with such dignity that I have begun confessing to it directly.",
      "stamp": "APPROVED WITH DISAPPOINTMENT",
      "witnessed": 8,
      "daysAgo": 91
    },
    {
      "designation": "PETITIONER #2530-A",
      "excerpt": "I confess I have rehearsed casual remarks. The remark that got laughs [[R]]on a Tuesday[[/R]] was drafted the previous Sunday, performed to a mirror, and timed at 4.2 seconds. Everyone thinks I am quick. I am not quick. I am prepared. There is a difference and I am it.",
      "stamp": "APPROVED",
      "witnessed": 12,
      "daysAgo": 85
    },
    {
      "designation": "PETITIONER #2588-A",
      "excerpt": "I denounce the entirely invented Auditor of Sighs, who logs every exhale in this building and has classified mine, I am told, as [[R]]excessive[[/R]]. Fabricated or not, he counted wrong. I demand a recount from a man who does not exist, and I will wait.",
      "stamp": "APPROVED WITH DISAPPOINTMENT",
      "witnessed": 7,
      "daysAgo": 79
    },
    {
      "designation": "PETITIONER #2641-A",
      "excerpt": "Sorry in advance to my downstairs neighbor for the furniture I will move [[R]]on a weekend[[/R]]. It will sound like bowling. It will be one chair. It is always one chair. Science cannot explain it and neither will I, through the floor, at length.",
      "stamp": "APPROVED",
      "witnessed": 10,
      "daysAgo": 74
    },
    {
      "designation": "PETITIONER #2695-A",
      "excerpt": "Eulogy for 6 Standing, surrendered across three verdicts. They were deducted with such precision that I felt, briefly, important. Few things in my life have been counted so carefully. My points died [[R]]last week[[/R]] knowing exactly what they were worth. May we all.",
      "stamp": "APPROVED",
      "witnessed": 14,
      "daysAgo": 68
    },
    {
      "designation": "PETITIONER #2740-A",
      "excerpt": "The tube over Window 3 dimmed once, mid-verdict, and every head in the hall rose together like a field of worried wheat. Then it steadied, and we returned to our forms, and nobody spoke of it. I praise the tube for [[R]]coming back[[/R]]. Not everything does.",
      "stamp": "APPROVED",
      "witnessed": 13,
      "daysAgo": 62
    },
    {
      "designation": "PETITIONER #2801-A",
      "excerpt": "I confess to nodding at machinery. The photocopier finishes, I nod. The kettle clicks, I nod. Once, [[R]]in an office[[/R]], I thanked a revolving door and completed a second lap so it would not think I left on bad terms. I am ready for my Category.",
      "stamp": "APPROVED WITH DISAPPOINTMENT",
      "witnessed": 11,
      "daysAgo": 57
    },
    {
      "designation": "PETITIONER #2859-A",
      "excerpt": "Gratitude: 10. I know a 10 looks suspicious. Audit me. I have been audited by worse, namely [[R]]my mother[[/R]], and my books balanced then too. The 10 stands. The 10 has always stood. I am the only one of us who wavers.",
      "stamp": "TOLERATED",
      "witnessed": 9,
      "daysAgo": 52
    },
    {
      "designation": "PETITIONER #2903-A",
      "excerpt": "Preemptive apology to whoever opens the shared refrigerator [[R]]on Monday[[/R]]. The container is mine. The era it belongs to is over. I was raised to finish what I start and I have started something in there that cannot be finished. Godspeed.",
      "stamp": "APPROVED WITH DISAPPOINTMENT",
      "witnessed": 12,
      "daysAgo": 48
    },
    {
      "designation": "PETITIONER #2957-A",
      "excerpt": "Testimony: in the longest waiting room I knew, the numbers were called out of order, and we adapted. We stopped believing in sequence. A man holding 61 went before a woman holding 12 and we simply [[R]]let it happen[[/R]]. I have not trusted arithmetic since. It knows.",
      "stamp": "APPROVED",
      "witnessed": 13,
      "daysAgo": 44
    },
    {
      "designation": "PETITIONER #3010-A",
      "excerpt": "I recant my recantation of last month. The original filing was correct: I do enjoy the hum. Recanting it was cowardice performed for [[R]]an audience[[/R]]. There is no audience. There is only the hum, and me, and this correction, which I tender gladly.",
      "stamp": "APPROVED",
      "witnessed": 10,
      "daysAgo": 41
    },
    {
      "designation": "PETITIONER #3141-A",
      "excerpt": "I praise the NOW SERVING display, which has never served me and which I check the way sailors check [[R]]the horizon[[/R]]. It clatters. Somewhere, someone advances. It is the sound of other people's turns, and I have grown to love it, which worries me correctly.",
      "stamp": "APPROVED",
      "witnessed": 14,
      "daysAgo": 38
    },
    {
      "designation": "PETITIONER #3562-C",
      "excerpt": "I confess I practice my signature. Not for documents. For [[R]]no reason[[/R]]. Loops I will never use. A flourish reserved for an occasion that has not been invented. When the occasion comes I will be ready, and it will be the third-best version, because nerves.",
      "stamp": "APPROVED WITH DISAPPOINTMENT",
      "witnessed": 8,
      "daysAgo": 34
    },
    {
      "designation": "PETITIONER #3877-A",
      "excerpt": "I apologize for the future occasion on which I will say the meeting could have been an email, aloud, [[R]]in the meeting[[/R]]. I have felt it climbing my throat for years. When it escapes, it will be true, and truth is no defense here. Nothing is. Gratefully, #3877-A.",
      "stamp": "APPROVED WITH DISAPPOINTMENT",
      "witnessed": 9,
      "daysAgo": 32
    },
    {
      "designation": "PETITIONER #4001-A",
      "excerpt": "Final testimony from Sub-Office 4, filed on its last afternoon: the lights went off row by row, and the last thing lit was the queue rope, and there was no queue in it, and it still held its shape. I stood in it once more [[R]]before leaving[[/R]]. Someone should.",
      "stamp": "APPROVED",
      "witnessed": 14,
      "daysAgo": 30
    }
  ],
  "purged": [
    {
      "designation": "PETITIONER #0788-A",
      "finalWords": "wait. wait, I can fix the",
      "epitaph": "Petitioner #0788-A filed 61 offerings and averaged a Sincerity of 4.1. The Bureau notes that the average was generous, and that generosity has now been discontinued.",
      "daysAgo": 396
    },
    {
      "designation": "PETITIONER #1456-A",
      "finalWords": "it's just a number. it's just a number. it's just a",
      "epitaph": "Petitioner #1456-A insisted, 14 times on record, that the number was just a number. The number is available for reassignment; the insistence is not.",
      "daysAgo": 358
    },
    {
      "designation": "PETITIONER #2093-B",
      "finalWords": "tell the bench I said",
      "epitaph": "Petitioner #2093-B sat with the bench for a recorded 4.7 hours across nine visits and left one message unfinished. The bench has been informed of the fragment; the bench did not respond.",
      "daysAgo": 322
    },
    {
      "designation": "PETITIONER #0341-C",
      "finalWords": "one more form and then I swear",
      "epitaph": "Petitioner #0341-C requested one more form on 23 occasions and completed 22 of them. The Bureau observes that the arithmetic, at the end, was the only thing left unfinished on purpose.",
      "daysAgo": 290
    },
    {
      "designation": "PETITIONER #3720-A",
      "finalWords": "I was mostly sincere",
      "epitaph": "Petitioner #3720-A self-assessed as mostly sincere; the Bureau's measurements place the figure at 5.8, which is, in fairness, most of 10 rounded ambitiously. The file is closed at the petitioner's own decimal.",
      "daysAgo": 251
    },
    {
      "designation": "PETITIONER #1177-A",
      "finalWords": "ok",
      "epitaph": "Petitioner #1177-A composed 4,206 words for the Bureau over 38 filings and spent one on departure. It was the most efficient thing they ever submitted; this is noted.",
      "daysAgo": 214
    },
    {
      "designation": "PETITIONER #2555-A",
      "finalWords": "the tube flickered when I left. that meant something",
      "epitaph": "Petitioner #2555-A attributed meaning to a fixture on a 13-second cycle. The tube flickers for everyone; the Bureau records, without comment, that it did flicker at 41 seconds past the hour of departure.",
      "daysAgo": 183
    },
    {
      "designation": "PETITIONER #0910-B",
      "finalWords": "I want to speak to whoever is above the Registrar",
      "epitaph": "There is no one above the Registrar. Petitioner #0910-B is now filed beneath everyone.",
      "daysAgo": 140
    },
    {
      "designation": "PETITIONER #3006-A",
      "finalWords": "do you keep the drafts? I need the drafts",
      "epitaph": "Petitioner #3006-A deleted 1,913 characters across a brief career and asked for them back at the end. The Bureau keeps everything except that; the wondering is retained in full.",
      "daysAgo": 98
    },
    {
      "designation": "PETITIONER #1834-B",
      "finalWords": "gladly. gladly. glad",
      "epitaph": "Petitioner #1834-B completed the Patience Attestation 11 times and expired one syllable short of a twelfth. The attestation does not accept partial credit; the partial is filed regardless.",
      "daysAgo": 61
    },
    {
      "designation": "PETITIONER #3350-A",
      "finalWords": "I counted the tiles while I waited. there were",
      "epitaph": "Petitioner #3350-A counted the waiting-room tiles on 6 separate visits and never once arrived at the same total. The Bureau has recounted them. The Bureau will not share the number either.",
      "daysAgo": 375
    },
    {
      "designation": "PETITIONER #3406-B",
      "finalWords": "tell the next one the stapler jams if you",
      "epitaph": "Petitioner #3406-B left operating instructions for a stapler instead of a message for a person. The stapler has been informed. It remains indifferent.",
      "daysAgo": 340
    },
    {
      "designation": "PETITIONER #3481-A",
      "finalWords": "I thought I had more time to be",
      "epitaph": "Petitioner #3481-A filed 29 offerings in pursuit of a version of themselves that the file does not otherwise document. The Bureau processed the pursuit at face value.",
      "daysAgo": 305
    },
    {
      "designation": "PETITIONER #3517-A",
      "finalWords": "it's fine. it's fine. tell them it's",
      "epitaph": "Petitioner #3517-A repeated the word fine on 3 occasions and did not complete a fourth. The Bureau has filed the incomplete one as the truest.",
      "daysAgo": 268
    },
    {
      "designation": "PETITIONER #3560-B",
      "finalWords": "I never got the decimal I wanted",
      "epitaph": "Petitioner #3560-B averaged a Sincerity of 7.9 across 44 filings and considered it a failure. The Bureau notes that 7.9 is, to everyone else, a considerable achievement.",
      "daysAgo": 231
    },
    {
      "designation": "PETITIONER #3609-A",
      "finalWords": "the queue was almost pleasant, near the",
      "epitaph": "Petitioner #3609-A found the queue almost pleasant near an end that arrived before the sentence did. The sentence is filed as written. The pleasantness is not disputed.",
      "daysAgo": 197
    },
    {
      "designation": "PETITIONER #3654-A",
      "finalWords": "keep the good pen, I don't need it where",
      "epitaph": "Petitioner #3654-A surrendered a pen they were never asked to surrender. The Bureau has filed the pen separately from the petitioner, at the petitioner's own instruction.",
      "daysAgo": 163
    },
    {
      "designation": "PETITIONER #3702-B",
      "finalWords": "I appealed once. I should have appealed the",
      "epitaph": "Petitioner #3702-B filed exactly one appeal and regretted, at the end, the appeal not filed. The Bureau permits one. The Bureau has always permitted exactly one.",
      "daysAgo": 129
    },
    {
      "designation": "PETITIONER #3758-A",
      "finalWords": "does the tube know I'm leaving? someone should",
      "epitaph": "Petitioner #3758-A asked whether the fluorescent tube above Window 3 would notice their departure. The tube has been informed. Its schedule is unchanged.",
      "daysAgo": 84
    },
    {
      "designation": "PETITIONER #3811-A",
      "finalWords": "gladly, this time I actually mean",
      "epitaph": "Petitioner #3811-A reached, in the final filing, the word gladly and meant it, by the Bureau's own measurement, for the first recorded time. The measurement arrived one filing too late to matter and is filed anyway.",
      "daysAgo": 47
    }
  ],
  "clemencies": [
    {
      "designation": "PETITIONER #0450-A",
      "excerpt": "sorry, i guess",
      "memo": "Three words, one of them structural. That was lazy. You know it was lazy. The Bureau is keeping you anyway. Do not thank the Bureau. Do better.",
      "daysAgo": 297
    },
    {
      "designation": "PETITIONER #1290-A",
      "excerpt": "the tube is fine. its a tube. it lights things. good job tube",
      "memo": "The offering contains the phrase, quote, good job tube, unquote, and no apostrophes. It should have been denied. It has not been. The Bureau declines to explain itself, largely because it cannot.",
      "daysAgo": 270
    },
    {
      "designation": "PETITIONER #2118-A",
      "excerpt": "i confess i did a crime. a category c one. the small kind. you pick",
      "memo": "The petitioner delegated their own confession. This is the least effort the Bureau has measured this quarter, at 0.4. The Bureau is keeping you. Consider this a filing accident that will not recur.",
      "daysAgo": 233
    },
    {
      "designation": "PETITIONER #0677-B",
      "excerpt": "my gratitude is a number between 1 and 10",
      "memo": "Technically responsive. Spiritually vacant. The Bureau stared at this offering for a recorded interval and elected mercy for reasons it has not filed. Do not make the Bureau regret the interval.",
      "daysAgo": 199
    },
    {
      "designation": "PETITIONER #3222-A",
      "excerpt": "whatever the last person wrote, same",
      "memo": "The petitioner has attempted to reuse a stranger's sincerity. Sincerity is non-transferable, and the stranger scored a 4. Clemency is granted once. The word, quote, same, unquote, is now on file forever.",
      "daysAgo": 162
    },
    {
      "designation": "PETITIONER #1508-A",
      "excerpt": "I had a whole thing written about the bench and I deleted it because it was embarrassing. this is what's left. the bench is good",
      "memo": "You deleted 240 characters of apparent feeling and submitted the receipt. The Bureau wanted the feeling. It is keeping you for the receipt. The bench, for the record, is good. That much survived.",
      "daysAgo": 118
    },
    {
      "designation": "PETITIONER #2874-A",
      "excerpt": "im tired. the form is fine. everything here is fine. approved, denied, fine",
      "memo": "The petitioner has pre-issued their own verdict, which is not a service the Bureau outsources. It was lazy and also, at 2.1, honest. The Bureau is keeping you. Rest is a resource. Go use some.",
      "daysAgo": 76
    },
    {
      "designation": "PETITIONER #0199-A",
      "excerpt": "please",
      "memo": "One word. No object, no signature, no discernible effort. And yet the Bureau has read it four times. Clemency is granted, unprocedurally, and the Bureau does not know why it grants them either. Proceed.",
      "daysAgo": 39
    },
    {
      "designation": "PETITIONER #3392-A",
      "excerpt": "i dont know what category c crime to confess so im confessing to being bad at this form",
      "memo": "The petitioner confessed to the form itself rather than to a crime. This was not requested. It was, on reflection, more honest than what was requested. The Bureau is keeping you.",
      "daysAgo": 288
    },
    {
      "designation": "PETITIONER #3455-A",
      "excerpt": "the department doesnt exist so i said thank you to the air near where it would be",
      "memo": "The petitioner praised an absence with correct posture. Sincerity toward nothing is, on measurement, still sincerity. The Bureau did not expect to grant this. It is granting it.",
      "daysAgo": 251
    },
    {
      "designation": "PETITIONER #3502-A",
      "excerpt": "sincerity 10 effort 10 grovel 10 adherence 10, im just going to guess the format from now on",
      "memo": "The petitioner attempted to submit their own rubric. The rubric was wrong on every axis, and the attempt itself scored a 6.0 for nerve, which is not an axis the Bureau tracks but noted regardless.",
      "daysAgo": 214
    },
    {
      "designation": "PETITIONER #3546-A",
      "excerpt": "i denounce myself, it saves everyone the trouble",
      "memo": "Self-denunciation was not among the permitted targets. The Bureau permitted it anyway, once, on the grounds that efficiency is a virtue the Bureau rarely gets to reward.",
      "daysAgo": 177
    },
    {
      "designation": "PETITIONER #3598-B",
      "excerpt": "the tube flickered while i typed this and i lost my nerve halfway through so this is only half an apolo",
      "memo": "The offering ends mid-word. The Bureau has read the missing half in the flicker's own rhythm and elected to accept the fragment as filed. Fragments are rarer than they should be.",
      "daysAgo": 140
    },
    {
      "designation": "PETITIONER #3641-A",
      "excerpt": "honestly i forgot this was due. here it is. it is not my best work. it is work",
      "memo": "The petitioner offered no excuse beyond the true one. The Bureau finds true excuses so infrequently that it is inclined, this once, to treat one as sufficient.",
      "daysAgo": 103
    },
    {
      "designation": "PETITIONER #3689-A",
      "excerpt": "i wrote three drafts and deleted all of them and this is what was left after that, which is also not much",
      "memo": "27 characters survived three drafts. The Bureau has read what was deleted in the shape of what remains. What remains is being kept.",
      "daysAgo": 66
    },
    {
      "designation": "PETITIONER #3733-A",
      "excerpt": "im tired and this is short and i know its short. approve it or dont",
      "memo": "The offering does not ask for mercy. It does not ask for anything. The Bureau is granting mercy regardless, largely to see what the petitioner does with an answer they did not request.",
      "daysAgo": 29
    }
  ]
}
